<split-steps #steps>
  <split-step [passo]="0">

    <form  [formGroup]="form">
      <div class="grid p-fluid">
        <div class="col-6">
          <span class="p-float-label">
            <input pInputText id="name" formControlName="name" />
            <label
              htmlFor="name"
              cservicoslass="pl-1 h-1rem flex align-items-center"
              for="float-label"

            >
              Nome da pasta
            </label>
          </span>
        </div>
        <div class=" col-6 ">
          <span class="p-float-label">
            <p-multiSelect
              formControlName="employees"
              inputId="employees"
              [options]="funcionarioComAcesso"
              optionLabel="name"
              appendTo="body"
              [filter]="false"
            ></p-multiSelect>
            <label for="employees">
              <p class="my-0">Funcionários com acesso</p>
            </label>
          </span>
        </div>


      </div>
    </form>
  </split-step>

  <ng-template #customNextButton>
    <div class="col-12 mt-7 px-0 text-right">
      <p-button (onClick)="saveForm()" [disabled]="!form.valid" class="ml-4" label="Salvar"></p-button>
    </div>
  </ng-template>
  <ng-template #customPreviousButton>
    <div class="col-12 mt-7 px-0">
      <p-button
        (onClick)="closeForm()"
        class=""
        severity="secondary"
        [outlined]="true"
        label="Cancelar"
      ></p-button>
    </div>
  </ng-template>
</split-steps>
